// Risk Assessment "Activity" field is stored as a single text column on the
// server but presented as four sub-sections in the UI. Helpers here keep the
// round-trip consistent across the Detail form, the Builder, and the print
// layout. Keep the headings in sync with the form labels — parseActivity
// matches on exactly these strings.

export const ACTIVITY_HEADINGS = [
  { key: 'name',        label: 'Activity name' },
  { key: 'description', label: 'Activity description' },
  { key: 'equipment',   label: 'Equipment overview' },
  { key: 'methodology', label: 'Methodology' },
];

export function parseActivity(raw) {
  const empty = { name: '', description: '', equipment: '', methodology: '' };
  if (!raw || typeof raw !== 'string') return empty;
  const labels = ACTIVITY_HEADINGS.map((h) => h.label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const re = new RegExp(`^(${labels.join('|')})\\s*:\\s*$`, 'gm');
  const hits = [];
  let m;
  while ((m = re.exec(raw)) !== null) {
    hits.push({ label: m[1], start: m.index, end: m.index + m[0].length });
  }
  if (hits.length === 0) {
    // Legacy plain-text activity — surface in the Description field so nothing is lost.
    return { ...empty, description: raw };
  }
  const out = { ...empty };
  for (let i = 0; i < hits.length; i++) {
    const heading = ACTIVITY_HEADINGS.find((h) => h.label === hits[i].label);
    if (!heading) continue;
    const contentStart = hits[i].end;
    const contentEnd = i + 1 < hits.length ? hits[i + 1].start : raw.length;
    out[heading.key] = raw.slice(contentStart, contentEnd).trim();
  }
  return out;
}

export function serializeActivity(fields) {
  const allEmpty = ACTIVITY_HEADINGS.every((h) => !(fields[h.key] || '').trim());
  if (allEmpty) return '';
  return ACTIVITY_HEADINGS
    .map((h) => `${h.label}:\n${(fields[h.key] || '').trim()}`)
    .join('\n\n');
}
